<template>
  <a-spin :spinning="spinning">
    <div class="">
      <div class="tk_table">
        <ele-table ref="rt" :columns="columns" :table-data="tableData" :total-items="totalItems" :is-full="true"
          :actionsType="actionsType" :current-page="pageNumber" :hide-row-selection="false"
          @emitOnPageChange="updatePageChange" @emitShowSizeChange="updateShowSizeChange">
          <!-- 查询条件 -->
          <a-row :gutter="8">
            <a-col :span="4">
              <a-select
                v-model="searchDto.organizationUnitId"
                show-search
                :filter-option="filterOption"
                style="width: 100%"
                :placeholder="l('请选择签约公司')"
                allowClear
              >
                <a-select-option
                  v-for="item in PayCompanys"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="4">
              <a-select
                v-model="searchDto.customerId"
                style="width: 100%"
                show-search
                :filter-option="filterOption"
                :placeholder="l('PleaseSelectCustomer')"
                allowClear
              >
                <a-select-option
                  v-for="item in Customers"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="4">
              <a-input
                v-model="searchDto.projectName"
                placeholder="请选择项目"
                @click="selectProjectModal"
              />
              <a-input v-model="searchDto.projectId" type="hidden" />
            </a-col>
            <a-col :span="4">
              <a-input
                v-model.trim="searchDto.keyword"
                :placeholder="l('姓名/身份证/手机号')"
              />
            </a-col>
            <a-col :span="4">
              <a-month-picker
                v-model="searchDto.paymentMonth"
                placeholder="发放月份"
                format="YYYY-MM"
                style="width: 100%"
              />
            </a-col>
            <a-col :span="4">
              <a-button type="primary" @click="getData" v-if="isGranted('Pages.LGModul.TaxAccumulation.Query')">
                <a-icon type="search" /> {{ l("搜索") }}
              </a-button>
              <a-button @click="clearFilterAndRefresh">
                {{ l("重置") }}
              </a-button>
            </a-col>
          </a-row>
          <!-- 操作按钮 -->
          <a-row :gutter="8" style="margin-top: 10px">
            <a-col class="gutter-row" align="right" :span="24">
              <a-button
                type="primary"
                v-if="isGranted('Pages.LGModul.TaxAccumulation.Export')"
                @click="exportToExcel"
              >
                <a-icon type="file-excel" />
                <span>{{ l("导出") }}</span>
              </a-button>
            </a-col>
          </a-row>
        </ele-table>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { AppComponentBase } from "@/shared/component-base";
import EleTable from "@/components/ele-table";
import moment from "moment";
import { fileDownloadService } from "@/shared/utils";
import { CommonServiceProxy } from "@/shared/common-service";
import SelectPageList from "@/components/linggong/select-page-list";
import { ModalHelper } from "@/shared/helpers";

export default {
  mixins: [AppComponentBase],
  name: "EmployeeTaxTotalIndex",
  components: { EleTable },
  data: function () {
    return {
      columns: [],
      tableData: [],
      actionsType: null,
      totalItems: 0,
      pageNumber: 1,
      searchDto: {
        organizationUnitId: undefined,
        customerId: undefined,
        projectId: undefined,
        projectName: "",
        keyword: "",
        paymentMonth: undefined,
        SkipCount: 0,
        MaxResultCount: 50
      },
      spinning: false,
      pagerange: [],
      PayCompanys: [],
      Customers: [],
      commonService: null,
    };
  },
  methods: {
    // 分页
    updatePageChange (newV) {
      let { page, pageSize } = newV;
      this.pageNumber = page;
      this.searchDto.SkipCount = (page - 1) * this.searchDto.MaxResultCount;
      this.getData();
    },
    updateShowSizeChange (newV) {
      let { current, size } = newV;
      this.pageNumber = 1;
      this.searchDto.MaxResultCount = size;
      this.getData();
    },
    clearFilterAndRefresh () {
      this.searchDto.organizationUnitId = undefined;
      this.searchDto.customerId = undefined;
      this.searchDto.projectId = undefined;
      this.searchDto.projectName = "";
      this.searchDto.keyword = "";
      this.searchDto.paymentMonth = undefined;
      this.pageNumber = 1;
      this.searchDto.SkipCount = 0;
      this.getData();
    },
    getData () {
      this.spinning = true;
      const requestData = {
        organizationUnitId: this.searchDto.organizationUnitId,
        customerId: this.searchDto.customerId,
        projectId: this.searchDto.projectId,
        keyword: this.searchDto.keyword,
        paymentMonth: this.searchDto.paymentMonth ? moment(this.searchDto.paymentMonth).format('YYYY-MM') : undefined,
        SkipCount: this.searchDto.SkipCount,
        MaxResultCount: this.searchDto.MaxResultCount
      };
      
      this.$api.request({
        url: this.$apiUrl + "/api/services/app/EmployeeTaxTotal/GetEmployeeTaxTotalPaged",
        method: "POST",
        data: requestData,
        headers: { "Content-Type": "application/json-patch+json" },
      }).then((res) => {
        this.spinning = false;
        if (res.status === 200) {
          let data = res.data;
          this.totalItems = data.totalCount || 0;
          this.totalPages = Math.ceil(
            (data.totalCount || 0) / this.searchDto.MaxResultCount
          );
          this.pagerange = [
            (this.pageNumber - 1) * this.searchDto.MaxResultCount + 1,
            Math.min(this.pageNumber * this.searchDto.MaxResultCount, data.totalCount || 0),
          ];
          this.tableData = (data.items || []).map(item => {
            return {
              ...item,
            }
          });
        } else {
          abp.message.warn(this.l("DefaultErrorMessage"));
        }
      }).catch((error) => {
        this.spinning = false;
        abp.message.error(this.l("DefaultErrorMessage"));
        console.error(error);
      });
    },
    initTable () {
      this.columns = [
        {
          title: "签约公司",
          dataIndex: "signCompanyName",
          sorter: false,
          align: "center",
          width: 150,
          scopedSlots: { customRender: "signCompanyName" },
        },
        {
          title: "客户名称",
          dataIndex: "customerName",
          sorter: false,
          align: "center",
          width: 150,
          scopedSlots: { customRender: "customerName" },
        },
        {
          title: "项目名称",
          dataIndex: "projectName",
          sorter: false,
          align: "center",
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: "projectName" },
        },
        {
          title: "项目代码",
          dataIndex: "projectCode",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "projectCode" },
        },
        {
          title: "姓名",
          dataIndex: "realName",
          sorter: false,
          align: "center",
          width: 100,
          scopedSlots: { customRender: "realName" },
        },
        {
          title: "手机号码",
          dataIndex: "phoneNumber",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "phoneNumber" },
        },
        {
          title: "身份证",
          dataIndex: "idCard",
          sorter: false,
          align: "center",
          width: 150,
          scopedSlots: { customRender: "idCard" },
        },
        {
          title: "个税缴纳月份",
          dataIndex: "taxYear",
          sorter: false,
          align: "center",
          width: 120,
          type:'custom',
          customRender: (text, record) => {
            return record.taxYear + '年' + record.taxMonth + '月';
          },
        },
        {
          title: "当月应纳税额",
          dataIndex: "currentTax",
          sorter: false,
          align: "center",
          width: 130,
          scopedSlots: { customRender: "currentTax" },
        },
        {
          title: "累计应纳税所得额",
          dataIndex: "totalTaxIncome",
          sorter: false,
          align: "center",
          width: 150,
          scopedSlots: { customRender: "totalTaxIncome" },
        },
        {
          title: "税率",
          dataIndex: "taxRate",
          sorter: false,
          align: "center",
          ellipsis: true,
          type:'custom',
          scopedSlots: { customRender: "taxRate" },
          customRender: (text, record) => {
            return record.taxRate + '%';
          },
        },
        {
          title: "速算扣除数",
          dataIndex: "deductionAmount",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "deductionAmount" },
        },
        {
          title: "累计应纳税额",
          dataIndex: "totalTax",
          sorter: false,
          align: "center",
          width: 130,
          scopedSlots: { customRender: "totalTax" },
        },
        {
          title: "累计已缴纳税额",
          dataIndex: "totalTaxPaid",
          sorter: false,
          align: "center",
          width: 130,
          scopedSlots: { customRender: "totalTaxPaid" },
        },
        {
          title: "累计收入",
          dataIndex: "totalIncome",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "totalIncome" },
        },
        {
          title: "当月收入",
          dataIndex: "currentIncome",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "currentIncome" },
        },
        {
          title: "往月累计收入",
          dataIndex: "lastMonthIncome",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "lastMonthIncome" },
        },
        {
          title: "累计费用",
          dataIndex: "totalAmount",
          sorter: false,
          align: "center",
          width: 120,
          scopedSlots: { customRender: "totalAmount" },
        },
        {
          title: "累计免税收入",
          dataIndex: "totalTaxFreeIncome",
          sorter: false,
          align: "center",
          width: 130,
          scopedSlots: { customRender: "totalTaxFreeIncome" },
        },
        {
          title: "累计减除费用",
          dataIndex: "totalDeductionAmount",
          sorter: false,
          align: "center",
          width: 130,
          scopedSlots: { customRender: "totalDeductionAmount" },
        },
        /*
        {
          title: "累计依法确定的其他扣除",
          dataIndex: "totalOtherDeduction",
          sorter: false,
          align: "center",
          width: 180,
          scopedSlots: { customRender: "totalOtherDeduction" },
        },
        */
      ];
      this.actionsType = {
        type: "employee-tax-total",
        isShow: false,
      };
    },
    selectProjectModal () {
      ModalHelper.create(
        SelectPageList,
        {
          selectType: "checkbox",
          title: "选择项目",
          url: "/api/services/app/Project/GetSelectPaged",
          searchPlaceholder: "项目名称/项目代码",
          columnsData: [
            {
              title: "项目名称",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "项目代码",
              dataIndex: "description",
              key: "description",
            },
          ],
        },
        {
          isChange: true,
          width: "860px",
          heigth: "650px",
        }
      ).subscribe((res) => {
        const { success, data } = res;
        if (success && data && data.length > 0) {
          const item = data[0];
          this.searchDto.projectId = item.id;
          this.searchDto.projectName = item.name;
        }
      });
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getAllPayCompanys () {
      let options = {
        url: this.$apiUrl + "/api/services/app/Organization/GetSelectList",
        method: "GET",
      };
      return this.$api
        .request(options)
        .then((res) => {
          if (res.status == 200) {
            this.PayCompanys = [];
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // 将返回的 text 字段映射为 label，以适配下拉选择组件
                this.PayCompanys.push({
                  label: res.data[i].text,
                  value: res.data[i].value,
                  invoiceType: res.data[i].invoiceType,
                  taxCategoryName: res.data[i].taxCategoryName,
                  subjectName: res.data[i].subjectName,
                  productName: res.data[i].productName
                });
              }
            }
          }
        })
        .catch((e) => {
          console.error('获取签约公司列表失败:', e);
          throw e;
        });
    },
    getAllCutomer () {
      let options = {
        url: this.$apiUrl + "/api/services/app/Customer/GetCustomerOption",
        method: "GET",
      };
      this.$api
        .request(options)
        .then((res) => {
          if (res.status == 200) {
            this.Customers = [];
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                this.Customers.push(res.data[i]);
              }
            }
          }
        })
        .catch((e) => {
          console.error('获取客户列表失败:', e);
          throw e;
        });
    },
    exportToExcel () {
      this.spinning = true;
      const requestData = {
        organizationUnitId: this.searchDto.organizationUnitId,
        customerId: this.searchDto.customerId,
        projectId: this.searchDto.projectId,
        keyword: this.searchDto.keyword,
        paymentMonth: this.searchDto.paymentMonth ? moment(this.searchDto.paymentMonth).format('YYYY-MM') : undefined,
        SkipCount: 0,
        MaxResultCount: this.totalItems || 50000
      };
      
      this.$api.request({
        url: this.$apiUrl + "/api/services/app/EmployeeTaxTotal/ExportEmployeeTaxTotal",
        method: "POST",
        data: requestData,
        headers: { "Content-Type": "application/json-patch+json" },
      }).then((res) => {
        this.spinning = false;
        if (res.status === 200) {
          if (res.data && res.data.fileName && res.data.fileToken) {
            fileDownloadService.downloadTempFile(res.data);
          } else {
            abp.message.warn(this.l("导出失败"));
          }
        } else {
          abp.message.error(res.statusText || this.l("导出失败"));
        }
      }).catch((error) => {
        this.spinning = false;
        abp.message.error(this.l("导出失败"));
        console.error(error);
      });
    }
  },
  created () {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    // 初始化数据，即使接口失败也不影响页面渲染
    this.getAllPayCompanys();
    this.getAllCutomer();
    this.getData();
  },
  mounted () {
    // 在 mounted 中初始化表格列，确保组件已完全挂载
    this.$nextTick(() => {
      this.initTable();
    });
  },
};
</script>

<style scoped>
.tk_table {
  padding: 10px;
}
</style>

